import { render, staticRenderFns } from "./ChangePrice.vue?vue&type=template&id=82a554fa&"
import script from "./ChangePrice.vue?vue&type=script&lang=js&"
export * from "./ChangePrice.vue?vue&type=script&lang=js&"
import style0 from "./ChangePrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports